import { LoginSso } from 'components/User';
import { connect } from 'react-redux';
import { userLogin } from 'actions/user';
import { push } from 'react-router-redux';

const mapStateToProps = (state) => {
  return {
    isFetching: state.user.isFetching,
    userProfile: state.user.profile
 };
};

const mapDispatchToProps = (dispatch) => ({
  userLogin(user) {
    dispatch(userLogin(user)).then(() => {
        let searchParams = new URLSearchParams(window.location.search);
        let redirect = searchParams.get("redirect");
        let loginUrl = "/login";

        if (redirect && redirect !== "/") {
          loginUrl = `${loginUrl}?redirect=${encodeURIComponent(redirect)}`;
        }

        dispatch(push(loginUrl));
    });
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginSso);

